export default "__VITE_ASSET__BQZp7UCH__"